import _get from 'lodash/get';

import { Google, GoogleTransformers, Pixall, PixallTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from './utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;
const { DataLayerTransformer, inventoryTransformer: pixallInventoryTransformer } = PixallTransformers;

/**
 * @summary Sends an Google link track for compare signin button click
 * @events event1, event6
 */
export function compareSigninClick({ data = {} }, option) {
    const { inheritPageData } = data;
    const vehicleData = googleInventoryTransformer({}, { target: 'vehicle' }, inheritPageData);

    Google.sendClickEvent({
        eventElement: 'my-at',
        eventResult: 'cta::sign-in',
        eventData: {
            vehicle: {
                ...vehicleData,
                description: undefined,
                sellerType: undefined,
            },
        },
    }, option);

    return {};
}

/**
 * @summary Sends Google and Pixall Impressions for CompareListings Modal
 * @events Google: event72 Pixall: event 3, event 4
 */
export const compareListingsModalPageView = (metadata = {}, option = {}) => {
    const {
        data,
        dataLayer = {},
    } = metadata;

    const { compareListings = [], eLotListingId, pixallData } = data;

    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const { pageInstanceId: pageinstantid = '' } = DataLayerTransformer.getPageAttributes(dataLayer);

    compareListings?.forEach((inventory, index) => {
        let listingType = 'compare';
        let cmp = 'comp_v_lstg';

        if (index === compareListings.length - 1 && inventory?.id === eLotListingId) {
            listingType = 'elot';
            cmp = 'dl_v_lstg - compare modal';
        }

        const vehicle = pixallInventoryTransformer.getInventoryData(inventory);
        vehicle.listingType = listingType;
        vehicle.listingCode = _get(inventory, 'owner.id', null);

        const pixallPayload = {
            eventSource: 'vehicle',
            pageType: pageId === 'fyc_vdp' ? 'vdp' : 'vlp',
            label: cmp,
            pageinstantid,
            pageId,
            ...vehicle,
            ...pixallData,
            vehicles: [vehicle],
        };

        Pixall.sendImpression({ dataLayer }, pixallPayload, option);
    });

    const ecommerceCategory = 'ecom_vehicle-inventory';
    const eventResult = 'compare';

    Google.sendImpressions(metadata, {
        event: 'ecom_event',
        eventElement: 'listings',
        eventAction: 'ecom-impression',
        eventResult,
        eventNonInteractive: true,
        ecommerce: {
            impressions: compareListings.map((inventory, index) => ({
                ...googleInventoryTransformer(
                    inventory,
                    {
                        target: 'ecommerce',
                        dataLayer,
                        eventResult,
                        vehicleListingPosition: index,
                    }
                ),
                id: eventResult,
                name: eventResult,
                category: ecommerceCategory,
                list: ecommerceCategory,
            })),
        },
    }, option);

    return {};
};

export const compareListingsDrawerClick = ({
    data = {},
    pixallData,
    dataLayer = {},
    state,
}, option = {}) => {
    const { clickType = '', par = 'comp_v_add', inventoryId, inheritPageData } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const { pageInstanceId: pageinstantid = '' } = DataLayerTransformer.getPageAttributes(dataLayer);
    const listingTypeSuffix = clickType ? `::${clickType}` : '';
    const eventResult = `cta::compare${listingTypeSuffix}`;
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);

    Pixall.sendClickEvent({
        eventSource: 'vehicle',
        eventType: 'click',
        label: par,
        pageId,
        pageType: 'vlp',
        listingType: 'alp',
        inventory,
        pageinstantid,
        ...pixallData,
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'compare',
        eventResult,
        eventData: {
            vehicle: {
                ...vehicleData,
                clickType: clickType || inventory.clickType,
            },
        },
    }, option);

    return { cmp: par };
};

export function compareListingSendOffer({
    data = {},
    dataLayer = {},
    state,
}, option = {}) {
    const { inventoryId } = data;
    const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
    const inventory = getInventoryOwnerById(state, inventoryId);
    const payload = {
        eventSource: 'vehicle',
        eventType: 'click',
        program: 'DealerDotCom',
        label: 'cta::send-offer',
        feature: 'compare',
        pageId,
        pageType: 'vdp',
        inventory,
    };

    Pixall.sendClickEvent(payload, dataLayer, option);
    return {};
}

export function compareAddListingClick({
    data = {},
    dataLayer = {},
    state,
}, option = {}) {
    const { clickType = '', inventoryId, quickAction = false } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const listingType = clickType ? `::${clickType.toLowerCase()}` : '';
    const clickSource = quickAction ? '-ellipsis' : '';
    const label = `cta::compare${listingType}${clickSource}`;

    const payload = {
        eventSource: 'application',
        eventType: 'click',
        program: 'DealerDotCom',
        label,
        feature: 'compare',
        pageId: 'fyc_srl',
        pageType: 'vlp',
        inventory,
    };

    Pixall.sendClickEvent(payload, dataLayer, option);
    return {};
}

export default {
    compareSigninClick,
    compareListingsModalPageView,
    compareListingsDrawerClick,
    compareListingSendOffer,
    compareAddListingClick,
};
